// import axios from 'axios';
// axios.defaults.baseURL = "http://106.14.82.40:8082";
String.prototype.format = String.prototype.f = function () {
    var s = this,
        i = arguments.length;

    while (i--) {
        s = s.replace(new RegExp('\\{' + i + '\\}', 'gm'), arguments[i]);
    }
    return s;
};
// get请求
export function reqGet(serviceUrl,reqData,methodCallback){
    this.axios.get(serviceUrl,{params:reqData})
    .then((res)=>{
        if(res.data.code==200&& res.data.bizCode=="0000"){
            if(typeof(methodCallback) == 'function'){
                methodCallback(res.data.result);
            }
        }else{
            this.$message({
                message:res.data.message,
                type:'warning',
                duration:'1000'
            });
            
        }
    }).catch(err=>{
        this.$message({
            message:'服务器繁忙',
            type:'error',
            duration:'1000'
        });
    })
}
// post请求
export function reqPost(serviceUrl,reqData,methodCallback){
    this.axios.post(serviceUrl, reqData).then(res => {
        if(res.data.code==200&& res.data.bizCode=='0000'){
            this.$message({
                message:res.data.message,
                type:'success',
                duration:'1000'
            });
            if(typeof(methodCallback) == 'function'){
                methodCallback(res.data);
            }
        }else {
            this.$message({
                message:res.data.message,
                type:'warning',
                duration:'1000'
            });
        }
        
    })
    .catch(err=>{
        this.$message({
            message:'服务器繁忙',
            type:'error',
            duration:'1000'
        });
    })
}
// put请求
export function reqPut(serviceUrl,reqData,methodCallback){
    this.axios.put(serviceUrl,reqData).then(res => {      
        if(res.data.code==200&& res.data.bizCode=="0000"){
            this.$message({
                message:res.data.message,
                type:'success',
                duration:'1000'
            });
            if(typeof(methodCallback) == 'function'){
                methodCallback(res.data);
            }
        }else{
            this.$message({
                message:res.data.message,
                type:'warning',
                duration:'1000'
            });
        }
    }).catch(err=>{
        this.$message({
            message:'服务器繁忙',
            type:'error',
            duration:'1000'
        });
    })
}
// del请求
export function reqDel(serviceUrl,note,reqData,methodCallback){
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(serviceUrl).then(res => {
            if (res.data.code == 200 && res.data.bizCode=="0000") {
                // this.$message.success(res.data.message);
                this.$message({
                    message:res.data.message,
                    type:'success',
                    duration:'1000'
                });
                if(typeof(methodCallback) == 'function'){
                    methodCallback(res.result);
                }
            }else{
                // this.$message.error(res.data.message); 
                this.$message({
                    message:res.data.message,
                    type:'warning',
                    duration:'1000'
                });
            }
        }).catch(err => {
            this.$message({
                message:"服务器繁忙",
                type:'error',
                duration:'1000'
            });
        })
    }).this.$message({
        type: 'info',
        message: '已取消删除'
      });
}

export function transformDateFormat(date, fmt) {
    if (!date) return date;
    date = new Date(date);
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
}